<template>
  <v-icon color="white">person</v-icon>
</template>

<script>
  import UsersClient from './Users/UsersClient.vue';
  import {Event} from '@/plugins/bus';

  export default {
    props: ['value'],
    mixins: [UsersClient],
    data() {
      return {
        user: null,
      };
    },
    methods: {
      async addAzureAdUser(user) {
        const newUser = {
          id: user.id,
          givenName: user.givenName,
          surname: user.surname,
          mail: user.mail,
          garages: [],
        };

        await this.updateUser(newUser, false);
      },
      onLoggedIn() {
        this.getCurrentUser().then(user => {
          this.user = user;
          if (this.user) {
            return;
          }

          const newUser = this.$authService.user;
          this.addAzureAdUser(newUser);
        });
      }
    },
    created() {
      this.$bus.$on(Event.UserAuthenticated, this.onLoggedIn);
    },
    destroyed() {
      this.$bus.$off(Event.UserAuthenticated, this.onLoggedIn);
    },
  };
</script>
